import { render, staticRenderFns } from "./UiChartTooltip.vue?vue&type=template&id=15571380&"
import script from "./UiChartTooltip.vue?vue&type=script&lang=js&"
export * from "./UiChartTooltip.vue?vue&type=script&lang=js&"
import style0 from "./UiChartTooltip.vue?vue&type=style&index=0&id=15571380&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports